export enum HeaderLocalhostKeys {
  PARTNER_HEADER_FEATURES = 'partner_header_features',
}
